import { render, staticRenderFns } from "./CustomerInfoCard.vue?vue&type=template&id=59fb6fb2&scoped=true&"
import script from "./CustomerInfoCard.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoCard.vue?vue&type=style&index=0&id=59fb6fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb6fb2",
  null
  
)

export default component.exports